<template>
  <div class="chatbot_wrap" @click="clickHandle">
    <i class="iconfont iconduihuaxiaozhi icon-chatbot"></i>
  </div>
</template>

<script>
import { HttpRequest } from 'utils/'
export default {
  data() {
    return {}
  },
  methods:{
    clickHandle() {
      HttpRequest({url:'/professional/chatbot/'})
      if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        //说明是移动端
        window.open('https://assistant-of-fighting-ncovid-19.sobot.com/chat/h5/v2/index.html?sysnum=ff8c5dd4ad604393abb1798d81e110af&channelid=7')
      } else {
        //说明是pc端
        window.open('https://assistant-of-fighting-ncovid-19.sobot.com/chat/pc/v2/index.html?sysnum=ff8c5dd4ad604393abb1798d81e110af&channelid=3')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chatbot_wrap{
  width:56px;
  height:56px;
  background:rgba(254,144,74,1);
  border-radius: 50%;
  box-shadow:0px 2px 8px 0px rgba(255,170,116,1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 9;
  right: 0.15rem;
  bottom: 0.64rem;
  .icon-chatbot{
    font-size: 24px;
    color: #ffffff;
  }
}
</style>